import React, { Component, useState } from "react";
import { Switch, Redirect, Route } from "react-router-dom";
import Login from './login'
import Dashboard from './dashboard'
export default () => {

    const [token, setToken] = useState(null)

    // console.log(token)

    return (
        <>
            {!token && <Login setToken={setToken} />}
            {token && <Dashboard token={token} setToken={setToken} />}

        </>

    )
}




